<div class="message-files" *ngIf="message != null">
    <header [hidden]="message.files.length == 0">
        <h4 *ngIf="show" (click)="toggleAttachments()"><em>{{message.files.length}}</em> <span class="arrow-up">Attachment{{message.files.length > 1 ? 's':''}}</span></h4>
        <h4 *ngIf="!show" (click)="toggleAttachments()"><em>{{message.files.length}}</em> <span class="arrow-down">Attachment{{message.files.length > 1 ? 's':''}}</span></h4>
      </header>
    <div [hidden]="!show">
        <core-files-list-notes
            *ngIf="notesCounter != null"
            [files]="message.files"
            [notes]="notesCounter"
            [menu]="menu"
            [context]="context"
            (menuClick)="onMenuClick($event)"
            (actionClick)="openNotes($event)"
            (iconDownloadClick)="onActionDownloadClick($event)"
        ></core-files-list-notes>
        <!-- alternative way because pdfjs web viewer can't be initialized several times in same component when selectedFile changes-->
        <div  *ngIf="message.files.length > 0" >
            <div *ngFor="let file of message.files">
                <core-file-notes *ngIf="selectedFile != null && selectedFile.id == file.id"
                    [file]="selectedFile"
                    [urlPrefix]="prefixUrl+'/messages/'+message.id"
                    [urlAnnotationsPrefix]="'/messages/'+message.id"
                    [context]="context"
                    [canCreateNotes]="canCreateNotes"
                    (saved)="notesSaved($event)"
                ></core-file-notes>
            </div>
        </div>
    </div>
</div>
